export default {
    title: 'New version of application has been found',
    button: {
        notNow: 'Ask later',
        ignore: 'Ignore',
        refresh: 'Refresh application'
    }
};
